/*
 * @Author: edvardchen
 * @Date:   2016-11-11 16:12:09
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-08-07 17:24:50
 */
// @flow
import { connect } from 'react-redux';
import _ from 'lodash';
import React from 'react';
import autobind from 'core-decorators/lib/autobind';
import update from 'immutability-helper';
import querystring from 'query-string';
import urlUtil from '../../utility/url';
import { distributeReport, distributeTest, openWeiShiH5Url } from '../../utility/reportDistribute';
import Loading from 'uistyles/comby/loading/index';
// import {
//   buildArticleQBUrl,
//   galleryQBUrl,
// } from '@tencent/qb-article-util/lib/urlHelper';

import { contextTypes } from '../../HOCs/withRoute';

import { isomorphicConfig, track, shareQS, listenToScroll } from '../../utility';
import { isAndroid } from '../../utility/UA';
import shareContextTypes from './contextTypes';
import MediaList from '../Media/List';

import styles from './ArticleContainer.scss';
// import { container, shareIcon } from '../../containers/base.scss';
import { container } from '../../containers/base.scss';
import { loadDownloadScene } from '../../actions/sharepage';
import { refreshRMP, initRMP, getShareURlDocId, initClipboard } from '../../utility/ClipperForRMP';
import isFeedsFast from '../../utility/isFeedsFast';
import { isLoadKuaiBao } from '../../utility/PageConfigDataForShare';

declare var browser;

const toggleDBLabel = (items, installed) => {
  if (installed === undefined) {
    return items;
  }
  const label = _.get(isomorphicConfig, 'share.relatedNews.downloadLabel');
  if (!label) {
    return items;
  }

  // const LIMIT = 4;
  return items.map((item) => {
    // 不做以前的限制，瀑布流式下拉加载
    const first = item.labels[0];
    if (first && first.text === label) {
      if (installed) {
        return update(item, {
          share: {
            $set: false,
          },
          labels: {
            $splice: [[0, 1]], // shift
          },
        });
      }
    }
    if (!installed && item.fromType !== 'configure') {
      return update(item, {
        share: {
          $set: true,
        },
        labels: {
          $unshift: [
            {
              text: label,
              colorType: 2,
            },
          ],
        },
      });
    }

    return item;
  });
};
const onItemExposure = (event = {}) => {
  const { url } = event;
  if (url && distributeTest(url) === 0) {
    // 微视曝光上报
    distributeReport({
      logType: 1,
      from: 0,
      sourceId: '0_3',
      local: 'share_0',
    });
  }
};
class RecommListInShare extends React.PureComponent<{
  installed: boolean,
  items: Array<Object>,
  bottomTips: Array<Object>,
  exposureSharelp: Object,
  dispatch: Function,
}> {
  static contextTypes = {
    ...contextTypes,
    ...shareContextTypes,
  };

  static shareLabel = 'feeds_article';
  constructor(props) {
    super(props);
    const allItems = toggleDBLabel(this.props.items, this.props.installed) || [];
    const listItem = allItems && allItems.length > 10 ? allItems.splice(0, 10) : allItems.splice(0, allItems.length);
    const loaddone = !(allItems.length > 0);
    this.state = {
      allItems,
      listItem,
      loading: false,
      loaddone,
    };
  }
  componentDidMount() {
    setTimeout(() => {
      const { items, bottomTips, exposureSharelp } = this.props;
      // const { items } = this.props;

      const first = items[0];
      if (first && !bottomTips) {
        const {
          isGallery,
          // tagId,
          title,
          docId,
          url,
        } = first;
        const ch = this.context.currentChannel;
        const params = { ch, url, gallery: isGallery };
        const qbUrl = `${window.location.origin}/share/${docId}?${querystring.stringify(params)}`;
        // if (!isGallery) {
        //   qbUrl = buildArticleQBUrl({
        //     docId,
        //     ch,
        //     url,
        //     business: 'coolread',
        //     immediate: true,
        //   });
        // } else {
        //   qbUrl = galleryQBUrl({
        //     docId,
        //     tagId,
        //     ch
        //   });
        // }
        this.context.setDownloadBar({
          url: qbUrl,
          title,
          image: first.thumbs[0],
        });
      } else if (bottomTips && bottomTips instanceof Array && bottomTips.length > 0) {
        const editBottomTips = this.TransformationBottomTips(bottomTips);
        this.context.setDownloadBar({
          installed: this.props.installed,
          SlideBanner: true,
          list: editBottomTips,
          exposureSharelp,
        });
        this.initRMPCreated(editBottomTips, this.state.listItem);
      }
    }, 300);

    try {
      this.scrollWatch = listenToScroll(() => {
        if (!this.state.loaddone && window.pageYOffset + window.innerHeight >= document.body.clientHeight - 5) {
          this.setState({ loading: true });
          setTimeout(() => {
            this.loadMoreItem();
          }, 300);
        }
      });
    } catch (e) {
      console.info(e);
    }
  }

  componentWillUnmount() {
    this.scrollWatch && this.scrollWatch.remove();
  }

  // 初始化写入当前文章Id与底Bar文章Id进入剪切板
  initRMPCreated = (editBottomTips, listItem) => {
    const docIdArr = [];
    const { exposureSharelp } = this.props;

    console.log(`当前文章信息exposureSharelp：${JSON.stringify(exposureSharelp)}`);
    // 当前文章docId
    if (exposureSharelp && exposureSharelp.docId) {
      docIdArr.push(exposureSharelp.docId);
    }
    // 底部Bar文章docId
    if (editBottomTips) {
      editBottomTips.forEach((el) => {
        const docId = getShareURlDocId(el.url);
        docId && docIdArr.push(docId);
      });
    }
    // 首次推荐文章docId
    if (listItem) {
      listItem.forEach((el) => {
        if (docIdArr.indexOf(el.docId) === -1 && el.docId) {
          docIdArr.push(el.docId);
        }
      });
    }
    initRMP(docIdArr)
      .then((obj) => {
        const firstDocId = docIdArr.length > 0 ? docIdArr[0] : '';
        if (obj[firstDocId]) {
          initClipboard(obj[firstDocId]);
        }
      })
      .catch((error) => {
        console.log(`调用剪切板数据异常：${error}`);
      });
  };

  // 按需加载调用剪切板接口数据
  loadMoreInitRmpCreate = (listItem) => {
    const docIdArr = [];
    if (listItem) {
      listItem.forEach((el) => {
        el.docId && docIdArr.push(el.docId);
      });
    }
    initRMP(docIdArr);
  };

  loadMoreItem = () => {
    const { listItem, allItems } = this.state;
    if (allItems.length === 0) {
      this.setState({
        loading: false,
        loaddone: true,
      });
      return;
    }
    const tempItems = allItems.length > 10 ? allItems.splice(0, 10) : allItems.splice(0, allItems.length);
    const newListItem = listItem.concat(tempItems);
    this.setState({
      loading: false,
      listItem: newListItem,
    });
    this.loadMoreInitRmpCreate(tempItems);
  };

  TransformationBottomTips = (data) => {
    const retData = data.map((item) => {
      const { isGallery, title, docId, url } = item;
      const ch = this.context.currentChannel;
      const params = { ch, url, gallery: isGallery };
      const qbUrl = `${window.location.origin}/share/${docId}?${querystring.stringify(params)}`;
      return {
        url: qbUrl,
        title,
        image: item.thumbs[0],
      };
    });
    return retData;
  };

  @autobind
  onItemCLick(event, { docId, isGallery, url, share, fromType }) {
    // return false 可以阻止底部articleForShare里面的点击事件
    if (isAndroid(window.navigator.userAgent) && /source=baipai/.test(window.location.href)) {
      track({
        location: 'sharelp',
        action: 'click',
        object: 'sharelp_baipai_click',
      });
    }
    this.props.dispatch(loadDownloadScene('recommend')); // 点击推荐文章场景，标志来源：推荐

    const ch = this.context.currentChannel;
    if (url && distributeTest(url) === 0) {
      // 微视点击上报
      distributeReport({
        logType: 2,
        from: 0,
        sourceId: '0_3',
        local: 'share_0',
      });
      openWeiShiH5Url(url, {}, '0_3', {}, true);
      return false;
    }
    let listIndex = 0;
    if (this.props.items && docId) {
      for (let i: number = 0; i < this.props.items.length; ) {
        if (this.props.items[i].fromType !== 'configure') {
          listIndex += 1;
        }
        if (this.props.items[i].id === docId) {
          break;
        }
        i += 1;
      }
    }
    if (fromType === 'configure' && url) {
      window.location.href = url;
      track({
        location: 'sharelp',
        action: 'click',
        object: 'sharelp_rengong',
        id: this.props.exposureSharelp && this.props.exposureSharelp.docId,
        ch: this.props.exposureSharelp && this.props.exposureSharelp.ch,
      });
      return false;
    }
    let reportObject = `sharelp_hotnews${listIndex}`;
    let liveObject = ''; // 拉活
    let newObject = ''; // 拉新
    if (fromType === 'configure_floatvideo') {
      reportObject = 'sharelp_VDFC02';
      liveObject = 'sharelp_VDFC03';
      newObject = 'sharelp_VDFC04';
    } else if (fromType === 'configure_ugcvideo') {
      reportObject = 'sharelp_SMVD02';
      liveObject = 'sharelp_SMVD03';
      newObject = 'sharelp_SMVD04';
    }
    track({
      location: 'sharelp',
      action: 'click',
      object: reportObject,
      id: this.props.exposureSharelp && this.props.exposureSharelp.docId,
      ch: this.props.exposureSharelp && this.props.exposureSharelp.ch,
    });
    const urlObj = urlUtil.parse(url);
    const isBookOrigin = urlObj.host === 'bookshelf.html5.qq.com'; // 兼容书城的url地址
    let qbUrl = url;
    console.log('this.props.installed', this.props.installed);

    if (this.props.installed && !isBookOrigin) {
      const params = { ch, url, gallery: isGallery, cardmode: 1 };
      qbUrl = docId ? `${window.location.origin}/share/${docId}?${querystring.stringify(params)}` : qbUrl;
      refreshRMP(docId); // 点击推荐文章场景，写入剪切板
      // 全部拉活
      this.context.openQb({
        url: qbUrl,
        label: RecommListInShare.shareLabel,
      });
      liveObject &&
        track({
          location: 'sharelp',
          action: 'click',
          object: liveObject,
          id: this.props.exposureSharelp && this.props.exposureSharelp.docId,
          ch: this.props.exposureSharelp && this.props.exposureSharelp.ch,
        });
      return false;
    }

    if (share && !isBookOrigin) {
      // 进行部分拉新
      // this.context.download(RecommListInShare.shareLabel);
      const params = { ch, url, gallery: isGallery, cardmode: 1 };
      qbUrl = docId ? `${window.location.origin}/share/${docId}?${querystring.stringify(params)}` : qbUrl;
      refreshRMP(docId); // 点击推荐文章场景，写入剪切板
      this.context.downloadOrOpenQb({
        url: qbUrl,
        label: RecommListInShare.shareLabel,
        hideMaskModal: true,
      });
      newObject &&
        track({
          location: 'sharelp',
          action: 'click',
          object: newObject,
          id: this.props.exposureSharelp && this.props.exposureSharelp.docId,
          ch: this.props.exposureSharelp && this.props.exposureSharelp.ch,
        });
      return false;
    }
    track({
      location: 'share',
      action: 'comsume',
      object: RecommListInShare.shareLabel,
    });
    if (!isBookOrigin) {
      const params = querystring.stringify({
        url,
        ch,
        ...shareQS(this.context.location.query),
      });
      qbUrl = `/share/${docId}?${params}`;
    }
    browser.coolread.openExternalPage(qbUrl);
    return false;
  }

  @autobind
  onClickBtn() {
    this.props.dispatch(loadDownloadScene('other')); // 点击推荐文章底部按钮，标志来源：其他
    const ch = this.context.currentChannel;
    this.context.downloadOrOpenQb({
      url: `${window.location.origin}/feeds?ch=${ch}`,
      label: 'recomm_bottom',
      hideMaskModal: true,
    });
    track({
      location: 'sharelp',
      action: 'click',
      object: 'sharelp_seemorenews',
      id: this.props.exposureSharelp && this.props.exposureSharelp.docId,
      ch: this.props.exposureSharelp && this.props.exposureSharelp.ch,
    });
  }

  render() {
    // const allItems = toggleDBLabel(this.props.items, this.props.installed);
    // console.log('======allItems====', allItems);
    const { listItem, loading, loaddone } = this.state;
    if (!listItem.length) {
      return null;
    }
    const isKb = isFeedsFast() || false;

    // 拉新拉活看点快报
    const isKuaibao = isLoadKuaiBao();

    return (
      <div
        className="item mg-t"
        style={{ paddingLeft: 0, paddingRight: 0 }}
        ref={(node) => {
          this.el = node;
        }}
      >
        <MediaList onItemCLick={this.onItemCLick} items={listItem} onItemExposure={onItemExposure} />
        {loading && <Loading icon="dot"></Loading>}
        {loaddone && (
          <div className={container} onClick={this.onClickBtn}>
            <div className={`${styles.downloadBtn} ${isKb || isKuaibao ? 'is-kb__sharelp_btn' : ''}`}>
              {/* <i className={shareIcon}></i> */}
              {/* 打开QQ浏览器，查看更多精彩内容 */}
              只有1%的人看到了这里，不打开试试么
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect(({ installer: { installed } }) => ({ installed }))(RecommListInShare);
